// @flow

import { createAction } from 'redux-actions';

export const hideFlashBanner = createAction<'HIDE_FLASH_BANNER', any>('HIDE_FLASH_BANNER');

export const setActiveTab = createAction<'SET_ACTIVE_TAB', any>('SET_ACTIVE_TAB');

export const addApplicationLoader = createAction<'ADD_APPLICATION_LOADER', any>(
  'ADD_APPLICATION_LOADER',
);
export const removeApplicationLoader = createAction<'REMOVE_APPLICATION_LOADER', any>(
  'REMOVE_APPLICATION_LOADER',
);



// WEBPACK FOOTER //
// ./src/actions/application/index.js